interface Props {
  fillColor?: string;
}

export default function CartFilledSVG({ fillColor = '#40444E' }: Props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.24 5.58H18.84L15.46 2.2C15.19 1.93 14.75 1.93 14.47 2.2C14.2 2.47 14.2 2.91 14.47 3.19L16.86 5.58H7.14L9.53 3.19C9.8 2.92 9.8 2.48 9.53 2.2C9.26 1.93 8.82 1.93 8.54 2.2L5.17 5.58H4.77C3.87 5.58 2 5.58 2 8.14C2 9.11 2.2 9.75 2.62 10.17C2.86 10.42 3.15 10.55 3.46 10.62C3.75 10.69 4.06 10.7 4.36 10.7H19.64C19.95 10.7 20.24 10.68 20.52 10.62C21.36 10.42 22 9.82 22 8.14C22 5.58 20.13 5.58 19.24 5.58Z"
        fill={fillColor}
      />
      <path
        d="M19.05 12H4.86997C4.24997 12 3.77997 12.55 3.87997 13.16L4.71997 18.3C4.99997 20.02 5.74997 22 9.07997 22H14.69C18.06 22 18.66 20.31 19.02 18.42L20.03 13.19C20.15 12.57 19.68 12 19.05 12ZM12 19.5C9.65997 19.5 7.74997 17.59 7.74997 15.25C7.74997 14.84 8.08997 14.5 8.49997 14.5C8.90997 14.5 9.24997 14.84 9.24997 15.25C9.24997 16.77 10.48 18 12 18C13.52 18 14.75 16.77 14.75 15.25C14.75 14.84 15.09 14.5 15.5 14.5C15.91 14.5 16.25 14.84 16.25 15.25C16.25 17.59 14.34 19.5 12 19.5Z"
        fill={fillColor}
      />
    </svg>
  );
}
